// extracted by mini-css-extract-plugin
module.exports = {"grouping":"TitleChip_grouping__2OQ-K","icon":"TitleChip_icon__2Ds1T","text":"TitleChip_text__3qF2F","secondaryText":"TitleChip_secondaryText__2KXng"};